import styled from 'styled-components';

export const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 10px;
  padding: 0 8px;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f9fa;
  .action-elements {
    display: flex;
    align-items: center;
    button {
      padding: 0;
      border: none;
      height: fit-content;
      display: flex;
    }
  }

  p {
    font-size: 12px;
    line-height: 18px;
    white-space: normal;
  }
`;
